import { render, staticRenderFns } from "./AvanzaConfezioni.vue?vue&type=template&id=6a6b406c&"
import script from "./AvanzaConfezioni.vue?vue&type=script&lang=js&"
export * from "./AvanzaConfezioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports